import { render, staticRenderFns } from "./AnagraphicCerved.vue?vue&type=template&id=2bebf322&scoped=true&"
import script from "./AnagraphicCerved.vue?vue&type=script&lang=ts&"
export * from "./AnagraphicCerved.vue?vue&type=script&lang=ts&"
import style0 from "./AnagraphicCerved.vue?vue&type=style&index=0&id=2bebf322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bebf322",
  null
  
)

export default component.exports